module.exports = __webpack_public_path__ + "img/logo-gagarin.8e57af78.svg";